import { assign } from 'xstate'
import ApiFetcher from 'lib/api_fetcher'
import { isLastStep, nextStep } from 'utils/step_utils'
import i18n from 'i18n/config'

const setError = assign({
  error: i18n.t('validations:fill_all_fields')
})

const cleanError = assign({
  error: null
})

const setValidationError = assign({
  error: i18n.t('validations:fill_all_fields')
})

const setVehicle = assign({
  vehicle: (ctx, e) => e.vehicle
})

const setVehicles = assign({
  vehicles: (ctx, e) => e.data.data
})

const resetFeeQuantities = assign({
  vehicleFeeQuantities: () => ({})
})

const setFeeQuantity = assign({
  vehicleFeeQuantities: (ctx, e) => {
    const {
      serviceCode,
      feeDescription,
      quantity
    } = e

    return {
      ...ctx.vehicleFeeQuantities,

      [serviceCode]: {
        ...(ctx.vehicleFeeQuantities?.[serviceCode] || {}),
        [feeDescription]: quantity
      }
    }
  }
})

const stepName = 'vehiclesStep'

const fetchVehicles = (ctx) => {
  return new ApiFetcher({
    key: 'vehicles',
    endpoint: ctx.endpoints.axis_vehicles,
    method: 'POST',
    body: JSON.stringify({
      quote: ctx.quote_values
    })
  }).call()
}

const VehicleState = (config) => {
  return {
    initial: 'init',

    states: {
      init: {
        on: {
          '': {
            target: 'prepareFetchingVehicles'
          }
        }
      },

      prepareFetchingVehicles: {
        on: {
          '': {
            target: 'fetchingVehicles',
            actions: [
              'startSpinner',
              cleanError,
              resetFeeQuantities
            ]
          }
        }
      },

      fetchingVehicles: {
        invoke: {
          src: fetchVehicles,

          onDone: {
            target: 'waitingVehiclePick',
            actions: [
              setVehicles,
              'stopSpinner'
            ]
          },

          onError: {
            target: '#purchase.error',
            actions: [
              setError,
              'stopSpinner'
            ]
          }
        }
      },

      waitingVehiclePick: {}
    },

    on: {
      VEHICLE_SELECTION: {
        actions: [
          setVehicle,
          cleanError
        ]
      },

      VEHICLE_FEE_QTY_CHANGE: {
        actions: [
          setFeeQuantity
        ]
      },

      NEXT_STEP_CLICK: [
        {
          cond: (ctx) => Boolean(ctx.vehicle),
          target: isLastStep(config, stepName)
            ? '#purchase.reserving'
            : '#purchase.' + nextStep(config, stepName)
        },
        {
          actions: [
            setValidationError
          ]
        }
      ]
    }
  }
}

export default VehicleState
